/**
 * Chaves de `sessionStorage` do retorno do fluxo de credencial de um app.
 *
 * As três pontas precisam concordar no literal: o `main.ts` (que captura os params do provedor
 * antes do Angular subir), a página de callback (que os consome) e o modal de conectar (que grava
 * para onde voltar). Ficam neste arquivo sem imports de propósito, para o bootstrap poder importá-las
 * sem arrastar a feature no bundle inicial.
 */
export const APPS_CREDENTIAL_CALLBACK_KEY = 'flux:apps:credential-callback';
export const APPS_CREDENTIAL_RETURN_KEY = 'flux:apps:credential-return';
